'use client'

import { createContext, useEffect, useState, type PropsWithChildren } from 'react'
import { evalConsent } from '@/libs/consent/consent'
import { ConsentData } from '@/types/consent'

const emptyData = { consentReady: false }
export const ConsentContext = createContext<ConsentData>(emptyData)

type ConsentProviderProps = PropsWithChildren

export const ConsentProvider = ({ children }: ConsentProviderProps) => {
  const [consentData, setConsentData] = useState<ConsentData>(emptyData)

  useEffect(() => {
    try {
      evalConsent(setConsentData)
    } catch (error) {
      // Handle evalConsent errors gracefully
      console.error('Error evaluating consent:', error)
      setConsentData({
        consentReady: true,
        status: 'error',
      })
    }
  }, [])

  return <ConsentContext.Provider value={consentData}>{children}</ConsentContext.Provider>
}
